import React, {useCallback, useEffect, useRef, useState} from 'react';
import DatePicker from 'react-datepicker';
import InputMask from 'react-input-mask';
import { ReactComponent as Arrow } from 'assets/images/svg/arrow.svg';
import { ReactComponent as PrevArrow } from 'assets/images/svg/prev-arrow.svg';
import { ReactComponent as NextArrow } from 'assets/images/svg/next-arrow.svg';
import "react-datepicker/dist/react-datepicker.css";
import {useField} from 'formik';
import { format, getYear, getMonth } from 'date-fns'
import { userLang } from 'components/utils';

const dateLocale = require('date-fns/locale')

const monthByLang = {
    ru: ["янв", "фев", "мар", "апр", "май", "июн", "июл", "авг", "сен", "окт", "ноя", "дек",],
    en: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul","Aug", "Sep", "Oct", "Nov", "Dec"],
    es: ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic",],
}

const CustomHeader = (props)=> {
    const { date, increaseYear, decreaseYear, decreaseMonth, increaseMonth } = props

    const changers = ((trigger)=> {
        return (e)=> {
            e.preventDefault()
            const handlers = { increaseYear, decreaseYear, decreaseMonth, increaseMonth }
            handlers[trigger]()
        }
    })
    const lang = userLang().split('-')[0] || userLang()
    return (
        <hader className="my-date-picker-head">
            <div className="my-date-picker-head-input">
                <button onClick={changers('decreaseYear')}><PrevArrow/></button>
                <div>{getYear(date)}</div>
                <button onClick={changers('increaseYear')}><NextArrow/></button>
            </div>
            <div className="my-date-picker-head-input">
                <button onClick={changers('decreaseMonth')}><PrevArrow/></button>
                <div>{monthByLang[lang][getMonth(date)]}</div>
                <button onClick={changers('increaseMonth')}><NextArrow/></button>
            </div>
        </hader>
    )
}

export const DatePickerField = ({
    placeholder,
    name,
    error,
    onChange,
    value = '',
    isDisabled
}) => {
    const calendarRef = useRef()
    const [inputVal, setInputVal] = useState('')
    const [isOpen, setIsOpen] = useState(false);
    const [, , help] = useField(name)
    const [startDate, setStartDate] = useState(null);

    useEffect(()=> {
        if (value) {
            setStartDate(new Date(value))
            setInputVal(format(value, "dd.MM.yyyy"))
            help.setValue(format(value, "dd.MM.yyyy"))
        }
    }, [value, help])

    useEffect(()=> {
        const callback = (e)=> {
            if (calendarRef.current && !calendarRef.current.contains(e.target)) {
                setIsOpen(false);
            }
        }
        document.addEventListener('click', callback, false)
        return ()=> {
            document.removeEventListener('click', callback, false)
        }
    }, [value])

    const handleInputChange = useCallback((e)=> {
        setInputVal(e.target.value)
        help.setValue(e.target.value)
    }, [help])

    const handleChange = (date)=> {
        onChange && onChange(date)
        help.setValue(format(date, "dd.MM.yyyy"))
        setStartDate(date)
        setInputVal(format(date, "dd.MM.yyyy"))
    }

    const handleClick = (e) => {
        e.preventDefault()
        if (isDisabled) return
        setIsOpen(!isOpen)
    }

    return (
        <div className="my-date-picker" ref={calendarRef}>
            <label className={['my-date-picker-input', error ? 'error' : '', isDisabled ? 'is_disabled' : '' ].join(' ')}>
                <InputMask
                    mask="99.99.9999"
                    value={inputVal}
                    onChange={handleInputChange}
                    name={name}
                    type="text"
                    disabled={isDisabled}
                />
                <span className={['my-date-picker-placeholder', inputVal !== '' ? 'is_valid' : ''].join(' ')}>{placeholder}</span>
                <button className="my-date-picker-btn" onClick={handleClick}>
                    <Arrow />
                </button>
            </label>
            <span className="authorization__error">
              {error}
            </span>
            <div className="my-date-picker-popup">
                {isOpen &&
                    <DatePicker
                        renderCustomHeader={CustomHeader}
                        closeOnScroll={true}
                        onChange={handleChange}
                        selected={startDate}
                        inline
                        locale={dateLocale[userLang()] || null}
                    />
                }
            </div>
        </div>
    )
}
